import { Dropdown, Option, Caption1, makeStyles, tokens } from '@fluentui/react-components';
import { EyeRegular } from '@fluentui/react-icons';

import { SAVED_VIEW_OPTIONS, TSavedView } from '../../constants';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  label: {
    color: tokens.colorNeutralForeground3,
  },
  dropdown: {
    minWidth: '220px',
  },
});

type TProps = {
  value: TSavedView;
  onChange: (view: TSavedView) => void;
};

export const SavedViewSelector = ({ value, onChange }: TProps) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <EyeRegular className={classes.label} />
      <Caption1 className={classes.label}>Saved view</Caption1>
      <Dropdown
        aria-label="Saved view"
        className={classes.dropdown}
        selectedOptions={[value]}
        value={value}
        onOptionSelect={(_, data) => onChange(data.optionValue as TSavedView)}
      >
        {SAVED_VIEW_OPTIONS.map((view) => (
          <Option key={view} value={view} text={view}>
            {view}
          </Option>
        ))}
      </Dropdown>
    </div>
  );
};
